import styled from 'styled-components';

export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100vh;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
`;

export const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 220px;
  padding-bottom: 88px;
`;

export const SubTitleWrapper = styled.div`
  margin: ${({ theme }) => theme.spacing.s};
`;

export const SubTitleTextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;
export const BottomSheetWrapper = styled.div`
color: ${({ theme }) => theme.colors.eerieBlack};
`;

export const BottomSheetHeaderBlock = styled.div`
  padding: ${({ theme }) => theme.spacing.l} ${({ theme }) => theme.spacing.none} ${({ theme }) => theme.spacing.none} ${({ theme }) => theme.spacing.md};
  width: ${({ theme }) => theme.width.full};
  background-color: white;
  position: fixed;
`;

export const CompetitorBottomSheetContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.xm} ${({ theme }) => theme.spacing.m};
`;
